module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/landscape/deco_white-2a37e86384254dc7c2278521d86419fe.png";